import { useIonAlert } from '@ionic/react';

interface IConfirm {
  title?: string;
  confirmActionLabel?: string;
  cancelActionLabel?: string;
  inputs?: object[];
}
export const useConfirm = () => {
  const [presentAlert] = useIonAlert();
  return async ({
    title = `Confirm?`,
    confirmActionLabel = 'OK',
    cancelActionLabel = 'Cancel',
    inputs = [],
  }: IConfirm) => {
    return new Promise((resolve, reject) => {
      presentAlert({
        header: title,
        buttons: [
          {
            text: cancelActionLabel,
            role: 'destructive',
          },

          {
            text: confirmActionLabel,
            role: 'confirm',
          },
        ],
        inputs: inputs,
        onDidDismiss: (e: CustomEvent) => {
          if (e.detail.role === 'confirm') {
            resolve(e.detail.data);
          } else {
            reject();
          }
        },
      });
    });
  };
};
